export default __webpack_public_path__ + "static/media/jinrongqihuo.f003a7d4.png";